enum GeoStatus {
    granted = 'granted',
    notDetermined = 'notDetermined',
    denied = 'denied'
}

export default GeoStatus;
